module.exports = __webpack_public_path__ + "img/reports.a7752a63.svg";